<template>
<div class="view-wrapper">
    <div class="lg-layout">
        <div class="lg-main">
            <div class="lg-header-tit">
                <div class="lg-header-tit-logo"></div>
                <span class="lg-header-tit-txt">大眼睛账号登录</span>
            </div>

            <div class="login-box" v-show="!smsLogin">
                <div class="login-input">
                    <van-field v-model="mobile" name="mobile" left-icon="phone" clearable placeholder="请输入手机号" />
                </div>
                <div class="login-input">
                    <van-field v-model="password" name="password" type="password" clearable left-icon="lock" placeholder="请输入密码" />
                </div>
                <div class="btns-bg">
                    <van-button type="danger" size="large" :loading="loading" @click="login" round>登录</van-button>
                </div>
                <div class="link-area">
                    <a href="javascript:;" @click="smsLogin = true">短信验证码登录</a>
                    <span>|</span>
                    <a href="http://h5.daeyes.com.cn/reg.html">立即注册</a>
                    <span>|</span>
                    <a href="https://m.show.daeyes.com/#/login">忘记密码？</a>
                </div>
            </div>
            <div class="login-box" v-show="smsLogin">
                <div class="login-input">
                    <van-field v-model="mobile" name="mobile" left-icon="phone" clearable placeholder="请输入手机号" />
                </div>
                <div class="login-input">
                    <van-field v-model="imgCode" name="imgCode" clearable left-icon="photo" placeholder="请输图形验证码">
                        <template #extra>
                            <div style="width:130px;height:30px;text-align:right;">
                                <img :src="imgBase64" alt="图片验证码" @click="getImgCode" style="height:30px;" />
                            </div>
                        </template>
                    </van-field>
                </div>
                <div class="login-input">
                    <van-field v-model="smsCode" name="smsCode" clearable left-icon="lock" placeholder="请输短信验证码">
                        <template #button>
                            <van-button size="small" type="info" round :disabled="sentValidCode" @click="sendCode">
                                <span v-if="sentValidCodeSuccess">重新发送({{sentSecond}}s) </span>
                                <span v-else>发送验证码</span>
                            </van-button>
                        </template>
                    </van-field>
                </div>
                <div class="btns-bg">
                    <van-button type="danger" size="large" :loading="loading" @click="doSmsLogin" round>登录</van-button>
                </div>
                <div class="link-area">
                    <a href="javascript:;" @click="smsLogin = false">手机号密码登录</a>
                    <span>|</span>
                    <a href="http://h5.daeyes.com.cn/reg.html">立即注册</a>
                    <span>|</span>
                    <a href="https://m.show.daeyes.com/#/login">忘记密码？</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
const reg = {
    mobile: /^1[3456789]\d{9}$/, //手机号
};
import {
    mapActions
} from "vuex";
export default {
    data() {
        return {
            loading: false,
            mobile: "",
            password: "",
            smsCode: "",
            imgCode: "",
            imgBase64: "",
            smsLogin: false,
            uuid: "",
            sentValidCode: false,
            sentSecond: 60,
            sentValidCodeSuccess: false
        };
    },
    created() {
        this.getImgCode();
    },
    methods: {
        ...mapActions(["setLogin", "setUser"]),
        //验证手机号
        testMobile() {
            if (this.mobile === "") {
                this.$toast("请输入手机号");
                return false;
            }
            if (!reg.mobile.test(this.mobile)) {
                this.$toast("请输入正确的手机号");
                return false;
            }
            return true;
        },
        login() {
            let param = {
                mobile: this.mobile,
                password: this.password,
                openId: this.$store.state.uid,
            };
            //验证
            if (this.testMobile()) {
                if (this.password === "") {
                    this.$toast("请输入密码");
                    return false;
                }
                this.loading = true;
                this.$ajax
                    .post("/api/account/login", param)
                    .then((response) => {
                        if (response.data.code === 1) {
                            let token = "Bearer " + response.data.data.Token;
                            this.setLogin(token);
                            //获取用户信息
                            this.getUser();
                            this.loading = false;
                            let redirectPath = this.$route.query.redirect;
                            if (redirectPath) {
                                this.$router.push({
                                    path: redirectPath,
                                });
                            } else {
                                this.$router.push({
                                    name: "home",
                                });
                            }
                            //localStorage.setItem("token", "Bearer " + response.data.data.Token);
                            // sessionStorage.loginStatus = true;
                            // this.$toast("登录成功");
                            // this.$router.push({ name: gotoPath });
                        } else {
                            this.$toast(response.data.message);
                            this.loading = false;
                        }
                    })
                    .catch(function () {
                        //console.log(err);
                        this.loading = false;
                    });
            }
        },
        doSmsLogin() {
            let param = {
                mobile: this.mobile,
                smsCode: this.smsCode,
                openId: this.$store.state.uid,
            };
            //验证
            if (this.testMobile()) {
                if (this.smsCode.length !== 6) {
                    this.$toast("请输入密码");
                    return false;
                }
                this.loading = true;
                this.$ajax
                    .post("/api/account/smslogin", param)
                    .then((response) => {
                        if (response.data.code === 1) {
                            let token = "Bearer " + response.data.data.Token;
                            this.setLogin(token);
                            //获取用户信息
                            this.getUser();
                            this.loading = false;
                            let redirectPath = this.$route.query.redirect;
                            if (redirectPath) {
                                this.$router.push({
                                    path: redirectPath,
                                });
                            } else {
                                this.$router.push({
                                    name: "home",
                                });
                            }
                        } else {
                            this.$toast(response.data.message);
                            this.loading = false;
                        }
                    })
                    .catch(function () {
                        //console.log(err);
                        this.loading = false;
                    });
            }
        },
        getUser() {
            this.$ajax.get("/api/user").then((response) => {
                if (response.data.code === 1) {
                    this.$store.dispatch("setUser", response.data.data);
                    sessionStorage.setItem(
                        "user",
                        JSON.stringify(response.data.data)
                    );
                }
            });
        },
        getImgCode() {
            this.$ajax
                .get("/api/account/validcode?t=" + this.uuid)
                .then((response) => {
                    if (response.data.code === 1) {
                        //console.log(response);
                        this.imgBase64 = response.data.data.img;
                        this.uuid = response.data.data.uuid;
                    }
                });
        },
        //发送支付验证码
        sendCode() {
            if (!this.testMobile()) {
                return false;
            }
            if (this.imgCode.length !== 4) {
                this.$toast("请输入图形验证码");
                return false;
            }
            var obj = this;
            obj.sentValidCode = true;
            obj.sentSecond = 60;

            let param = {
                mobile: this.mobile,
                imgCode: this.imgCode,
                uuid: this.uuid
            };

            this.$ajax
                .post("/api/account/sendSmsCode", param)
                .then((response) => {
                    if (response.data.code === 1) {
                        //console.log(response);
                        obj.sentValidCodeSuccess = true;
                        //倒计时
                        obj._interval = setInterval(function () {
                            if (obj.sentSecond > 0) {
                                obj.sentSecond--;

                            } else {
                                clearInterval(obj._interval);
                                obj.sentValidCode = false;
                                obj.sentValidCodeSuccess = false;
                            }

                        }, 1000);
                    } else {
                        obj.sentValidCodeSuccess = false;
                        clearInterval(obj._interval);
                        obj.sentValidCode = false;
                    }
                    this.$toast(response.data.message);
                    this.getImgCode();
                })
                .catch(function () {
                    clearInterval(obj._interval);
                    obj.sentValidCode = false;
                });
        },
    },
};
</script>

<style lang="less" scoped>
.view-wrapper {
    height: 100%;
    background: #fff;
}

.lg {
    &-layout {
        width: 100%;
        margin: 0 auto 30px;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
    }

    &-main {
        position: relative;
    }

    &-header-tit {
        padding: 30px 0 20px;
        text-align: center;
        font-weight: normal;
    }

    &-header-tit-logo {
        width: 70px;
        height: 70px;
        margin: 0 auto 15px;
        background-image: url(../assets/image/logo-login.png);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
    }

    &-header-tit-txt {
        font-size: 18px;
        font-weight: normal;
        color: #000;
    }
}

@media only screen and (min-width: 520px) {
    .lg-layout {
        max-width: 80%;
    }
}

@media only screen and (min-width: 720px) {
    .lg-layout {
        max-width: 500px;
    }
}

.login-input {
    border-bottom: 1px solid #d3f3f3;
}

.login-input .van-cell {
    font-size: 16px;
    line-height: 30px;
}

.btns-bg {
    margin-top: 30px;
}

.link-area {
    text-align: center;
    margin-top: 20px;
}

.link-area a {
    color: #9b9b9b;
    padding: 0 8px;
}
</style>
